<script></script>

<h1>Inspiration</h1>

<p>I went for a field trip with my friends to the SafeTIST Farm. The owner of the place taught my friends and me how to cook eggs, both fried and omelette. I wanted to share my Knowledge with Everyone around the world, so I created this website.</p>
<p><b>Type of Project : Website!</b></p>
<img src="images/SafeTist.jpg" alt="">
